module.exports = __webpack_public_path__ + "static/english-e714de83326d24d9363bb056f1a37e32.jpg";